import { StudentAssessment } from '@/models/StudentAssessment';
import { KlassPedagogicalSheetRecordTypeEnum } from '@/utils/assessments/klassPedagogicalSheetRecordTypes';
import { StudentPedagogicalSheetRecord } from '@/utils/assessments/studentPedagogicalSheetRecordTypes';

export const toStudentPedagogicalSheetRecords = (
  assessments: StudentAssessment[],
): StudentPedagogicalSheetRecord[] =>
  assessments.map(assessment =>
    assessment.occurrenceAssessment
      ? {
          kind: KlassPedagogicalSheetRecordTypeEnum.OCCURRENCE,
          id: `occurrence-${assessment.id}`,
          datetime: assessment.createdAt ?? '',
          assessment,
        }
      : {
          kind: KlassPedagogicalSheetRecordTypeEnum.ASSESSMENT,
          id: `assessment-${assessment.id}`,
          datetime: assessment.createdAt ?? '',
          assessment,
        },
  );
